import * as actionTypes from "../actions";
import secureStorage from "../../helpers/locStore";
import cloneDeep from "lodash/cloneDeep";
import { ENVIRONMENT } from "../../config";
const initialState = {
  calculated_total: 0,
  items: [],
};

const calculateCartTotal = (items) => {
  console.log(items);
  let total = 0;
  // items.map((item) => {
  //   if (ENVIRONMENT === "development") {
  //     console.log(item.calculated_total);
  //   }
  //   total += parseFloat(item.calculated_total);
  // });
  return total;
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CART_ON_RELOAD:
      // set secureStorage to redux cart
      if (ENVIRONMENT === "development") {
        console.log(action.payload.cart, "payload cart ");
      }
      let storeClone = cloneDeep(action.payload.cart);
      if (ENVIRONMENT === "development") {
        console.log(storeClone, "deep clone store");
      }
      return storeClone;
    case actionTypes.ADD_CART_ITEM:
      let storageCart = secureStorage.getItem("cart");
      let storageClone = cloneDeep(storageCart);
      let currentItem = cloneDeep(action.payload.item);
      let index = action.payload.index;
      console.log(storageClone);
      // if (currentItem.addons.length <= 0) {
      //   let replaceIndex = storageClone.items.length;
      //   let itemExistList = storageClone.items.filter((item, index) => {
      //     if (item.id !== currentItem.id) {
      //       return true;
      //     } else {
      //       replaceIndex = index;
      //       return false;
      //     }
      //   });
      //   if (ENVIRONMENT == "development") {
      //     console.log("item exist", itemExistList);
      //   }
      //   if (index === null || index === undefined) {
      //     let items = [...itemExistList];
      //     items.splice(replaceIndex, 0, currentItem);
      //     storageClone["items"] = items;
      //     let calculated_total = calculateCartTotal(items);

      //     storageClone["calculated_total"] = calculated_total;
      //     secureStorage.setItem("cart", storageClone);
      //     if (ENVIRONMENT == "development") {
      //       console.log("added add-to-cart type item");
      //     }
      //     return storageClone;
      //   } else {
      //     storageClone.items[index] = currentItem;

      //     let calculated_total = calculateCartTotal(storageClone.items);

      //     storageClone["calculated_total"] = calculated_total;
      //     secureStorage.setItem("cart", storageClone);
      //     if (ENVIRONMENT == "development") {
      //       console.log("added add-to-cart type item");
      //     }
      //     return storageClone;
      //   }
      // } else {
      if (ENVIRONMENT === "development") {
        console.log("executing the else let's go");
      }
      if (index === null || index === undefined) {
        let items = [...storageClone.items, currentItem];
        storageClone["items"] = items;
        let calculated_total = calculateCartTotal(items);

        storageClone["calculated_total"] = calculated_total;
        secureStorage.setItem("cart", storageClone);
        if (ENVIRONMENT === "development") {
          console.log("added add-to-cart type item");
        }
        return storageClone;
      } else {
        if (ENVIRONMENT === "development") {
          console.log("hey reached the reducer");
        }
        storageClone.items[index] = currentItem;

        let calculated_total = calculateCartTotal(storageClone.items);

        storageClone["calculated_total"] = calculated_total;
        secureStorage.setItem("cart", storageClone);
        if (ENVIRONMENT === "development") {
          console.log("added add-to-cart type item");
        }
        return storageClone;
      }
    //}

    //   case actionTypes.REMOVE_CART_ITEM:
    //     // remove cart item and update secureStorage
    //     if (ENVIRONMENT == "development") {
    //       console.log("removing cart item");
    //     }
    //     let prod = cloneDeep(action.payload.item);
    //     let i = cloneDeep(action.payload.index);
    //     if (ENVIRONMENT == "development") {
    //       console.log(i);
    //     }
    //     let storage_cart = secureStorage.getItem("cart");
    //     let storage_clone = cloneDeep(storage_cart);
    //     if (i !== undefined && i !== null) {
    //       if (ENVIRONMENT == "development") {
    //         console.log("executing expected");
    //       }
    //       let newCartItems = storage_clone.items.filter((item, ind) => {
    //         return ind !== parseInt(i);
    //       });
    //       let updated_calculated_total = calculateCartTotal(newCartItems);
    //       let updatedState = {
    //         items: newCartItems,
    //         calculated_total: updated_calculated_total,
    //       };
    //       if (ENVIRONMENT == "development") {
    //         console.log(updatedState);
    //       }
    //       secureStorage.setItem("cart", updatedState);
    //       return updatedState;
    //     } else {
    //       if (ENVIRONMENT == "development") {
    //         console.log("executing unexpected");
    //       }

    //       let latest_list = storage_clone.items.filter((item) => {
    //         return item.id !== prod.id;
    //       });

    //       // let clone_remaining_items = cloneDeep(latest_list);
    //       // let updated_calculated_total = storage_cart.calculated_total - current_item[0].item_total_price;
    //       let updated_calculated_total = calculateCartTotal(latest_list);
    //       let updatedState = {
    //         items: latest_list,
    //         calculated_total: updated_calculated_total,
    //       };
    //       if (ENVIRONMENT == "development") {
    //         console.log(updatedState);
    //       }
    //       secureStorage.setItem("cart", updatedState);
    //       return updatedState;
    //     }
    //   case actionTypes.UPDATE_CART_ITEM:
    //     // // update cart item and update secureStorage
    //     // let storageCart = secureStorage.getItem("cart");
    //     // let storageClone = cloneDeep(storageCart);
    //     // let currentItem = cloneDeep(action.payload.item);
    //     // let index = action.payload.index;
    //     // let items = [...itemExistList, currentItem];
    //     // storageClone["items"] = items;
    //     // let calculated_total = calculateCartTotal(items);

    //     // storageClone["calculated_total"] = calculated_total;
    //     // secureStorage.setItem("cart", storageClone);
    //     // console.log("added add-to-cart type item");
    //     // return storageClone;
    //     let myLocalCart = secureStorage.getItem("cart");
    //     let myLocalClone = cloneDeep(myLocalCart);
    //     let myItem = cloneDeep(action.payload.item);

    //   case actionTypes.UPDATE_CART_BEFORE_ORDER:
    //     let current_store_clone = cloneDeep(action.payload.cart);
    //     // console.log(storeClone, "deep clone store");
    //     return current_store_clone;

    //   case actionTypes.RESET_CART:
    //     secureStorage.setItem("cart", { items: [], calculated_total: 0 });
    //     return {
    //       calculated_total: 0,
    //       items: [],
    //     };

    //   case actionTypes.POPITEM:
    //     let pcart = secureStorage.getItem("cart");
    //     let popCart = cloneDeep(pcart);
    //     let popIndex = action.payload.popIndex;
    //     let popTotal = 0;
    //     let resultPopCart = pcart.items.filter((popItem, popi) => {
    //       if (popi != popIndex) {
    //         // if (popItem.cu_status == 1) {
    //         popTotal += parseFloat(popItem.calculated_total);
    //         // }
    //         return true;
    //       }
    //     });
    //     if (ENVIRONMENT === "development") {
    //       console.log(resultPopCart);
    //     }

    //     secureStorage.setItem("cart", {
    //       items: resultPopCart,
    //       calculated_total: popTotal,
    //     });
    //     return {
    //       calculated_total: popTotal,
    //       items: resultPopCart,
    //     };
    default:
      return state;
  }
};

export default cartReducer;
